import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  isApiSuccessful: false,
  selectedDevice: null,
  selectedStatus: null,
  selectedSharedUid: null,
  requestedBy: null,
  goalsRequestedBy: null,
  selectedGoalsDate: null,
  openModal: false,
  //Performace Dashboard slices
  exequteQueryContent: [],
  exequteQueryCompareQuery: [],
  exequteQueryContentQuery2: [],
  exequteQueryContentQuery3: [],
  exequteQueryContentQuery4: [],
  exequteQueryCompareQuery4: [],
  exequteQueryContentQuery5: [],
  exequteQueryContentQuery6: [],
  selectedPage: null,
  display: false,
  isInitialized: false,
  selectedPeriod: "Month",
  addNewPageReqText: "",
  device: { label: "Mobile" },
  selectedInterval: { label: "Month", value: "month" },
  quarter: null,
  selectedPriode: dayjs(),
};

const pageSpeedPerformanceSlice = createSlice({
  name: "pageSpeedPerformance",
  initialState: initialState,
  reducers: {
    setIsApiSuccessful: (state, action) => {
      state.isApiSuccessful = action.payload;
    },
    setSelectedDevice: (state, action) => {
      state.selectedDevice = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setRequestedBy: (state, action) => {
      state.requestedBy = action.payload;
    },
    setGoalsRequestedBy: (state, action) => {
      state.goalsRequestedBy = action.payload;
    },
    setSelectedGoalsDate: (state, action) => {
      state.selectedGoalsDate = action.payload;
    },
    setOpenModal: (state, action) => {
      state.openModal = action.payload;
    },
    setExequteQueryContent: (state, action) => {
      state.exequteQueryContent = action.payload;
    },
    setExequteQueryCompareQuery: (state, action) => {
      state.exequteQueryCompareQuery = action.payload;
    },
    setExequteQueryContentQuery2: (state, action) => {
      state.exequteQueryContentQuery2 = action.payload;
    },
    setExequteQueryContentQuery3: (state, action) => {
      state.exequteQueryContentQuery3 = action.payload;
    },
    setExequteQueryContentQuery4: (state, action) => {
      state.exequteQueryContentQuery4 = action.payload;
    },
    setExequteQueryCompareQuery4: (state, action) => {
      state.exequteQueryCompareQuery4 = action.payload;
    },
    setExequteQueryContentQuery5: (state, action) => {
      state.exequteQueryContentQuery5 = action.payload;
    },
    setExequteQueryContentQuery6: (state, action) => {
      state.exequteQueryContentQuery6 = action.payload;
    },

    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },

    setDisplay: (state, action) => {
      state.display = action.payload;
    },
    setIsInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
    setSelectedPeriod: (state, action) => {
      state.selectedPeriod = action.payload;
    },
    setAddNewPageReqText: (state, action) => {
      state.addNewPageReqText = action.payload;
    },
    setDevice: (state, action) => {
      state.device = action.payload;
    },
    setSelectedInterval: (state, action) => {
      state.selectedInterval = action.payload;
    },
    setQuarter: (state, action) => {
      state.quarter = action.payload;
    },
    setSelectedPriode: (state, action) => {
      state.selectedPriode = action.payload;
    },
  },
});

export const {
  setIsApiSuccessful,
  setSelectedDevice,
  setSelectedStatus,
  setSelectedSharedUid,
  setRequestedBy,
  setGoalsRequestedBy,
  setSelectedGoalsDate,
  setOpenModal,
  setExequteQueryContent,
  setExequteQueryCompareQuery,
  setExequteQueryContentQuery2,
  setExequteQueryContentQuery3,
  setExequteQueryContentQuery4,
  setExequteQueryCompareQuery4,
  setExequteQueryContentQuery5,
  setExequteQueryContentQuery6,
  setSelectedPage,
  setDisplay,
  setIsInitialized,
  setSelectedPeriod,
  setAddNewPageReqText,
  setDevice,
  setSelectedInterval,
  setQuarter,
  setSelectedPriode,
} = pageSpeedPerformanceSlice.actions;
export default pageSpeedPerformanceSlice.reducer;
